module.exports = __webpack_public_path__ + "img/groupbuypage-location.9d83bafc.png";